module.exports = __webpack_public_path__ + "static/media/note2.b484f28d.svg";